import './index.css'
import Button from '../button'
import Logo from '../logo'

function Header({ CTA, URLForLogo, functionForButton, stateManipulator, CTA2, functionForButton2, context,hideIcons, displayAdditionalNavComponents}) {
    return (
        <div className="header" id={context ? context + "-header" : null}>
            <Logo url={URLForLogo} />

            <div id="nav-button-holder" style={{ display: CTA || CTA2 ? 'flex' : 'none' }}>
            {displayAdditionalNavComponents && (
                <div className="header__nav-links">
                    <a href="/use-cases">Use cases</a>
                    <a href="/roadmap">Roadmap</a>
                    <a href="https://blog.mako-app.com" target="_blank" rel="noopener noreferrer">Blog</a>
                </div>
            )}                {CTA2 && (
                    <Button
                        image={hideIcons ? null : './images/add-post.png'}
                        id="secondary-cta"
                        text={CTA2}
                        addedFunction={functionForButton2}
                        stateManipulator={stateManipulator}
                    />
                )}
                {CTA && (
                    <Button
                        image={hideIcons ? null : './images/add-post.png'}
                        text={CTA}
                        id="primary-cta"
                        addedFunction={functionForButton}
                        stateManipulator={stateManipulator}
                    />
                )}
            </div>
        </div>
    )
}

export default Header